import React from 'react';
import SelectInput from './SelectInput';

const QuizTypeSelectInput = ({ register, errors, name, helpText=null, className=null, validationRules = { required: 'Quiz type is required' } }) => {
  const quizTypeOptions = [
    { value: 'assessment', label: 'Assessment Quiz' },
    { value: 'learning', label: 'Learning Quiz' },
  ];

  return (
    <SelectInput
      label="Quiz Type"
      name={name}
      register={register}
      errors={errors}
      options={quizTypeOptions}
      validationRules={validationRules}
      helpText={helpText}
      className={className}
    />
  );
};

export default QuizTypeSelectInput;
